import { render, staticRenderFns } from "./ProfileIndex.vue?vue&type=template&id=f1425150&scoped=true&"
import script from "./ProfileIndex.vue?vue&type=script&lang=js&"
export * from "./ProfileIndex.vue?vue&type=script&lang=js&"
import style0 from "./ProfileIndex.vue?vue&type=style&index=0&id=f1425150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1425150",
  null
  
)

export default component.exports